import { WizardScreenContent } from './WizardScreenContent';
import { WizardScreenFooter } from './WizardScreenFooter';
import { WizardScreenHeader } from './WizardScreenHeader';
import { WizardScreenLayout } from './WizardScreenLayout';

type WizardScreenCompound = {
    Layout: typeof WizardScreenLayout;
    Header: typeof WizardScreenHeader;
    Content: typeof WizardScreenContent;
    Footer: typeof WizardScreenFooter;
};

export const WizardScreen: WizardScreenCompound = {
    Layout: WizardScreenLayout,
    Header: WizardScreenHeader,
    Content: WizardScreenContent,
    Footer: WizardScreenFooter,
};
